/**
 * Class recipes of the voice comparison. Its root is the named container `@container/voicepair`
 * and every size in it follows that name, so it lays out the same in the workspace shell and in
 * an overlay outside it: `@3xl/voicepair:` (768 px) sets the decision beside the listening,
 * `@5xl/voicepair:` (1024 px) sets the two sides beside each other and shows the key caps.
 */

/** Card surface of the comparison: rounded-2xl when narrow, rounded-xl from 768 px. */
export const PAIR_CARD =
  'rounded-2xl border border-border bg-card text-card-foreground @3xl/voicepair:rounded-xl'

/** Key caps and other keyboard-only hints: drawn where the view is as wide as a desktop. */
export const KEYS_ONLY = 'hidden @5xl/voicepair:flex'

/**
 * The comparison's page: one column when narrow — title, where the pair stands, listening,
 * evidence — and from 768 px of its own width the decision in a column beside them.
 */
export const PAIR_GRID =
  'grid grid-cols-1 gap-4 p-4 @3xl/voicepair:grid-cols-[minmax(0,1fr)_18rem] @3xl/voicepair:gap-x-6 @3xl/voicepair:p-6 @5xl/voicepair:grid-cols-[minmax(0,1fr)_20rem]'

/**
 * The decision's place: second when narrow, the side column from 768 px, in view while the rest
 * scrolls.
 */
export const PAIR_DECISION_COLUMN =
  '@3xl/voicepair:sticky @3xl/voicepair:top-6 @3xl/voicepair:col-start-2 @3xl/voicepair:row-span-3 @3xl/voicepair:row-start-1 @3xl/voicepair:self-start'

/** Everything else stays in the main column. */
export const PAIR_MAIN_COLUMN = 'min-w-0 @3xl/voicepair:col-start-1'
